module.exports = __webpack_public_path__ + "static/media/CreditCardBanescoLogo.ce70c766.svg";